import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as Sentry from '@sentry/browser';
import * as serviceWorker from './serviceWorker';

Sentry.init({ dsn: "https://6e6f7aced90f43b088fd18a2815c746c@sentry.io/1795417" });
ReactDOM.render(<App/>, document.getElementById('root'));

serviceWorker.unregister();
